// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.anticon[data-v-1c3be12b] {\r\n  font-size: 12px;\n}\n[data-v-1c3be12b] .ant-card-body {\r\n  padding-bottom: 0px;\n}\n[data-v-1c3be12b] .tox-tinymce {\r\n  height: 400px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
